/**
 * AdminAllUsersPanel — wires the All Users directory (§7) to the view-as flow
 * (§8). Kept separate from AllUsersDirectory so the directory stays a pure,
 * Clerk-free component (renderable in the offline harness); this wrapper owns
 * the impersonation hook, which requires a real Clerk session.
 */
import React from 'react';
import AllUsersDirectory, { DirectoryUser } from './AllUsersDirectory';
import { useViewAs } from '../../hooks/useViewAs';

export default function AdminAllUsersPanel() {
  const { start, error } = useViewAs();

  const onViewAs = async (u: DirectoryUser) => {
    const ok = window.confirm(
      `View as ${u.name} (${u.email})?\n\n` +
        `This opens a READ-ONLY impersonation session — you'll see exactly ` +
        `what they see, but no changes can be made until you exit view-as.`,
    );
    if (!ok) return;
    try {
      await start(u.clerk_user_id || u.user_id);
    } catch {
      /* surfaced via `error` below */
    }
  };

  return (
    <div className="space-y-3">
      {error && (
        <div
          className="rounded-lg px-4 py-2 text-sm"
          style={{ background: 'var(--color-bg-elevated)', border: '1px solid var(--color-needs-human-text)', color: 'var(--color-needs-human-text)' }}
        >
          {error}
        </div>
      )}
      <AllUsersDirectory onViewAs={onViewAs} />
    </div>
  );
}
